import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Back/forward (POP) navigations must keep their scroll position —
    // e.g. Cancel on the save-edit screen returns to the exact prior spot
    // on the other person's page. Only fresh navigations reset to top.
    if (navigationType === 'POP') return;
    // Use instant scroll to prevent visible scroll animation
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
